
import React from 'react';
import { Container, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSchool, faChalkboardTeacher, faHome, faFlask, faBook, faDumbbell } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import img from './../../assets/SKDLJPS.jpg';

const Majra = () => {
    const highlights = [
        { title: 'Academic Excellence', icon: faChalkboardTeacher, description: 'Rigorous curriculum with highly qualified faculty' },
        { title: 'Modern Infrastructure', icon: faHome, description: 'State-of-the-art facilities and comfortable residential quarters' },
        { title: 'Well-equipped Labs', icon: faFlask, description: 'Modern laboratories for practical learning' },
        { title: 'Extensive Library', icon: faBook, description: 'Wide range of books and learning resources' },
        { title: 'Sports Facilities', icon: faDumbbell, description: 'Extensive sports grounds for physical development' }
    ];

    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faSchool} className="me-2" />
                        Smt Kesari Devi Lohia Jairam Public School Lohar Majra Kurukshetra
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <div className="mb-4">
                    <img 
                        src={img} 
                        alt="Jairam Public School" 
                        style={{
                            width: '100%',
                            height: '370px',
                            objectFit: 'cover',
                            borderRadius: '20px',
                            boxShadow: '0 12px 40px rgba(30,60,114,0.15)'
                        }}
                    />
                </div>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faSchool} className="me-2" />
                            About Our School
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                SMT KESARI DEVI LOHIA JAIRAM PUBLIC SCHOOL, Lohar Majra, Kurukshetra an esteemed institution dedicated to nurturing young minds and fostering their holistic development. Our school stands as a beacon of excellence in the realm of military education in India.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                At Jairam Sainik School, we are committed to instilling values of discipline, integrity, and leadership among our students, preparing them to become responsible citizens and future leaders of our nation. Our rigorous academic curriculum is complemented by a diverse range of extracurricular activities, ensuring a well-rounded educational experience for our cadets.
                            </p>
                        </div>
                        
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Our highly qualified faculty members provide exemplary guidance and mentorship to our students, inspiring them to achieve their full potential, both academically and personally.
                            </p>
                        </div>
                        
                        <div className="mb-0">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Join us at Jairam Sainik School and embark on a transformative journey that will empower you to realize your dreams and aspirations, while also serving your country with honor and distinction.
                            </p>
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faHome} className="me-2" />
                            Infrastructure & Facilities
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                With state-of-the-art infrastructure and facilities, including modern classrooms, well-equipped laboratories, extensive sports grounds and comfortable residential quarters, we create a conducive learning environment that promotes growth and excellence.
                            </p>
                        </div>
                        
                        <div className="row justify-content-center">
                            {highlights.map((highlight, index) => (
                                <div key={index} className="col-md-6 col-lg-4 mb-3">
                                    <div 
                                        className="p-3 text-center rounded h-100"
                                        style={{
                                            background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                                            color: 'white',
                                            minHeight: '120px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            boxShadow: '0 4px 15px rgba(22,160,133,0.2)',
                                            transition: 'all 0.3s'
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.transform = 'scale(1.05)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(22,160,133,0.3)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.transform = 'scale(1)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(22,160,133,0.2)';
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={highlight.icon} 
                                            style={{ fontSize: '2.5rem', marginBottom: '15px' }}
                                        />
                                        <h6 className="mb-2 fw-bold">{highlight.title}</h6>
                                        <small style={{ fontSize: '0.85rem', opacity: '0.9' }}>{highlight.description}</small>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faChalkboardTeacher} className="me-2" />
                            Heritage & Excellence
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="mb-4">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                At Jairam Sainik School, we take pride in our rich heritage and tradition of producing leaders of tomorrow. Our alumni have excelled in various fields, making significant contributions to society and upholding the values instilled in them during their time at our institution.
                            </p>
                        </div>
                        
                        <div className="mb-0">
                            <p style={{ color: '#495057', lineHeight: '1.7', fontSize: '1.05rem' }}>
                                Whether it's academic pursuits, sports or co-curricular activities, we strive for excellence in everything we do, fostering a culture of excellence and camaraderie among our students.
                            </p>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default Majra;
